//package imports
import { toJS } from "mobx"

// project imports
import OptimizationStore from "modules/optimization/store/OptimizationStore"
import * as APITypes from "constants/API"
import axios from "utils/axios"

export const fetchCashFlowTableData = async (productData) => {

  // let reqObj = toJS(OptimizationStore.fetchIndividualProductTimeLineReqParam)

  // if(familyProductIdForSingleTab){
  //   // console.log('familyProductIdForSingleTab',familyProductIdForSingleTab);
  //   reqObj = {"family_product_id" : familyProductIdForSingleTab,"risk_type" : 'high'}    
  // }
  OptimizationStore.showMainLoading = true
  let reqObj = { "family_product_id": productData.data.family_product_id, "risk_type": productData.data.selectedRisk || 'high' }

  try {
    const response = await axios.post(APITypes.FETCH_PRODUCT_TIME_LINE, reqObj)
    OptimizationStore.showMainLoading = false
    return response
  } catch (error) {
    console.log(error)
    OptimizationStore.showMainLoading = false
  }

}

export const getCashFlowTableData = async (productData) => {
  OptimizationStore.showMainLoading = true
  let id = productData?.data?.family_product_id

  try {
    const response = await axios.get(`${APITypes.GET_LA_CASH_FLOW_DATA}${id}`)
    OptimizationStore.showMainLoading = false
    return response
  } catch (error) {
    console.log(error)
    OptimizationStore.showMainLoading = false
  }

}